import React, { Component } from 'react';
import { Row, Modal, Form, Input } from 'antd';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const data = this.props.form.getFieldsValue();
    this.props.form.validateFields(() => {
      this.props.handSubmit(data);
    });
  };

  render() {
    const { cancel, record } = this.props;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="合同使用"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="合同编号" {...formItemLayout}>
              <p>{record.no}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="所属人" {...formItemLayout}>
              <p>{record.belonging}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="订单编号" {...formItemLayout}>
              {getFieldDecorator('orderNo', {
                rules: [{ required: true, message: '订单编号不能为空！' }],
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="合同金额" {...formItemLayout}>
              {getFieldDecorator('price', {
                rules: [{ required: true, message: '合同金额不合法！' }],
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="客户名称" {...formItemLayout}>
              {getFieldDecorator('customName', {
                rules: [{ required: true, message: '公司名称不能为空！' }],
              })(<Input placeholder="公司名称" />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalUse.js